<template>
    <div
        v-if="ready"
        class="backgroundBody"
    >
        <nav-bar />
        <main
            role="main"
            class="container mt-4 contextContainer"
        >
            <router-view />
        </main>
        <footer
            v-if="hiddenFooter"
            class="footer"
        >
            <footer-view />
        </footer>
    </div>
</template>

<script>
import NavBar from '@/components/nav-bar.vue';
import { mapActions, mapState } from 'vuex';
import FooterView from '@/components/FooterView';

export default {
  components: {
    'nav-bar': NavBar,
    'footer-view': FooterView
  },
  computed: {
    ...mapState('cache', ['currentUser', 'dateSettings']),
    ...mapState('context', ['profile', 'hubConnected']),
    hiddenFooter() {
      return !this.$route.path.includes('chat');
    },
    ready() {
      return (
        this.profile
        && this.currentUser
        && this.dateSettings
        && this.hubConnected
      );
    }
  },
  created() {
    this.restoreContext()
      .then(() => {
        const token = this.$store.state.context.jwtToken;
        this.$hub.connect(token);
        this.getCache();
      })
      .catch(() => {
        this.$router.push({ name: 'Login' });
      });

    this.registerScrollBottomEvent();
  },
  methods: {
    ...mapActions('context', ['restoreContext']),
    ...mapActions('cache', ['getCache']),
    registerScrollBottomEvent() {
      const appElem = document.getElementById('app');
      const self = this;
      appElem.addEventListener('scroll', () => {
        if (appElem.scrollTop + appElem.clientHeight >= appElem.scrollHeight) {
          self.$events.emit('scrolled-to-bottom');
        }
      });
    }
  }
};
</script>

<style>
#app {
  background-color: var(--generalBackground);
  min-height: 100vh;
  height: 100vh;
  /*overflow: overlay;*/
}
.contextContainer {
  padding: 70px 0;
  width: 1200px;
  margin: 0 auto;
  box-sizing: border-box;
  position: relative;
  height: inherit;
  min-height: 100vh;
}
body {
  margin: 0 !important;
  overflow-x: hidden;
  overflow-y: auto;
  background-color: var(--generalBackground);
  font-size: 13px;
  font-family: Lato, sans-serif;
  color: black;
}
.h-100p {
  height: 100%;
}
.clearfix:after {
  content: "";
  display: table;
  clear: both;
}
.spacer {
  flex-grow: 1;
}
.backgroundBody {
  background-color: var(--backgroundGrey);
  height: initial;
}
.footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 100;
  height: 52px;
}
</style>
